import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { SharedModule } from 'src/app/shared/shared.module';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
  standalone: true,
  imports: [CommonModule, PipesModule, DirectivesModule, SharedModule, RouterModule],
})
export class BannerComponent implements OnInit {
  @Input() title: string | null;
  @Input() subtitle: string = '';
  @Input() showBtn: boolean = false;
  @Input() isHomePage: boolean = false;
  @Input() titleLink: string | null = null;
  populations = Populations;

  constructor() {}

  ngOnInit(): void {}
}
